import { Controller } from 'stimulus'
import { useDebounce } from 'stimulus-use'
import { showLoader } from '../classes/loaderExtensions'
import Rails from '@rails/ujs'

export default class extends Controller {
  static debounces = ['debouncedFetchFilesDetails']
  static targets = ['checkbox', 'selectAll', 'totalFiles']

  connect() {
    useDebounce(this)

    document.addEventListener(
      'files-list#fetchFilesDetails',
      this.fetchFilesDetails.bind(this)
    )

    $('#files-loader').show()
    if (this.showFileDetailsCheckboxesSelected()) {
      this.fetchFilesDetails()
    }
  }

  fetchFiles(page) {
    let formData = $('#files-filter-form').serialize()

    if (page) { formData = formData + '&' + page }

    Rails.ajax({
      type: 'get',
      url: '/files',
      data: formData,
      dataType: 'script',
      error: () => alert('Something went wrong')
    })
  }

  debouncedFetchFilesDetails() {
    this.fetchFilesDetails()
  }

  fetchFilesDetails() {
    let url = '/files_details?'

    showLoader('#files-loader')
    this.showFileDetailsCheckboxes().forEach(checkbox => {
      // The 'false' checkbox value must be passed to save the user preference
      url = `${url}&${checkbox}=${document.getElementById(checkbox).checked}`
    })

    const fileIds = $('.c-checkbox__input[id^=files-list-item]').map(function() {
      return 'file_ids[]=' + this.dataset.referenceId
    }).get().join('&')

    Rails.ajax({
      type: 'get',
      url: url + '&' + fileIds,
      dataType: 'script',
      error: () => alert('Something went wrong')
    })
  }

  showFileDetailsCheckboxes() {
    return ['show_file_labels', 'show_file_issues', 'show_file_linked_items']
  }

  showFileDetailsCheckboxesSelected() {
    let nothingSelected = true
    this.showFileDetailsCheckboxes().forEach(checkbox => {
      if (document.getElementById(checkbox)?.checked) {
        nothingSelected = false
      }
    })

    return !nothingSelected
  }

  handleNewPage(event) {
    event.preventDefault()
    const href = event.currentTarget.href
    this.fetchFiles(href.substr(href.search('page'), href.length))
  }
}
